// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2y3Ls","productName":"Table_productName__1dqwF"};